import module from 'recursoshumanos/module.js'

module.config(($stateProvider) => {
  $stateProvider.state('recursoshumanos.cargarMovimientos', {
    url: '/cargarmovimientos?{empresaId}&{clase:int}&{registroPatronalId:int}',
    reloadOnSearch: false,
    data: {title: 'Carga de lotes IMSS'},
    resolve: {
      empresaId: ($stateParams) => $stateParams.empresaId,
      clase: ($stateParams) => $stateParams.clase,
      registroPatronalId: ($stateParams) => $stateParams.registroPatronalId,
    },
    template: '<recursoshumanos-cargarmovimientos empresa-id="empresaId" clase="clase" registro-patronal-id="registroPatronalId"/>',
    controller: ($scope, empresaId, clase, registroPatronalId) => {
      $scope.empresaId = empresaId
      $scope.clase = clase
      $scope.registroPatronalId = registroPatronalId
    },
  })
})



// WEBPACK FOOTER //
// ./src/recursoshumanos/routes/recursoshumanos/cargarMovimientos.js